import React from 'react';
import { SvgIcon } from 'seduo-ui';
import classNames from 'classnames';
const CategoryItem = ({ title, iconKind, link, showBoxes, showIcon, isActive }) => (<div className={classNames('categories__item', {
        'categories__item--boxes': showBoxes,
    })}>
        <a href={link} className={classNames('categories__link', {
        'categories__link--boxes': showBoxes,
        'categories__link--with-icon': showIcon,
        'categories__link--active': isActive,
    })}>
            {showIcon && (<SvgIcon kind={iconKind} className={classNames('categories__icon', {
            'categories__icon--boxes': showBoxes,
        })}/>)}
            <span className="categories__title">{title}</span>
        </a>
    </div>);
CategoryItem.defaultProps = {
    iconKind: 'Categories',
    link: '#',
    showBoxes: false,
    showIcon: true,
    isActive: false,
};
export default CategoryItem;
